/******************************************************************************
 * This file was generated by ZenStack CLI.
 ******************************************************************************/

/* eslint-disable */
// @ts-nocheck

import type { Prisma, TenantScreeningCriteria } from ".zenstack/models";
import type { UseMutationOptions, UseQueryOptions, UseInfiniteQueryOptions, InfiniteData } from '@tanstack/react-query';
import { getHooksContext } from '@zenstackhq/tanstack-query/runtime-v5/react';
import { useModelQuery, useInfiniteModelQuery, useModelMutation } from '@zenstackhq/tanstack-query/runtime-v5/react';
import type { PickEnumerable, CheckSelect, QueryError, ExtraQueryOptions, ExtraMutationOptions } from '@zenstackhq/tanstack-query/runtime-v5';
import type { PolicyCrudKind } from '@zenstackhq/runtime'
import metadata from './__model_meta';
type DefaultError = QueryError;
import { useSuspenseModelQuery, useSuspenseInfiniteModelQuery } from '@zenstackhq/tanstack-query/runtime-v5/react';
import type { UseSuspenseQueryOptions, UseSuspenseInfiniteQueryOptions } from '@tanstack/react-query';

export function useCreateTenantScreeningCriteria(options?: Omit<(UseMutationOptions<(TenantScreeningCriteria | undefined), DefaultError, Prisma.TenantScreeningCriteriaCreateArgs> & ExtraMutationOptions), 'mutationFn'>) {
    const { endpoint, fetch } = getHooksContext();
    const _mutation =
        useModelMutation<Prisma.TenantScreeningCriteriaCreateArgs, DefaultError, TenantScreeningCriteria, true>('TenantScreeningCriteria', 'POST', `${endpoint}/tenantScreeningCriteria/create`, metadata, options, fetch, true)
        ;
    const mutation = {
        ..._mutation,
        mutateAsync: async <T extends Prisma.TenantScreeningCriteriaCreateArgs>(
            args: Prisma.SelectSubset<T, Prisma.TenantScreeningCriteriaCreateArgs>,
            options?: Omit<(UseMutationOptions<(CheckSelect<T, TenantScreeningCriteria, Prisma.TenantScreeningCriteriaGetPayload<T>> | undefined), DefaultError, Prisma.SelectSubset<T, Prisma.TenantScreeningCriteriaCreateArgs>> & ExtraMutationOptions), 'mutationFn'>
        ) => {
            return (await _mutation.mutateAsync(
                args,
                options as any
            )) as (CheckSelect<T, TenantScreeningCriteria, Prisma.TenantScreeningCriteriaGetPayload<T>> | undefined);
        },
    };
    return mutation;
}

export function useCreateManyTenantScreeningCriteria(options?: Omit<(UseMutationOptions<Prisma.BatchPayload, DefaultError, Prisma.TenantScreeningCriteriaCreateManyArgs> & ExtraMutationOptions), 'mutationFn'>) {
    const { endpoint, fetch } = getHooksContext();
    const _mutation =
        useModelMutation<Prisma.TenantScreeningCriteriaCreateManyArgs, DefaultError, Prisma.BatchPayload, false>('TenantScreeningCriteria', 'POST', `${endpoint}/tenantScreeningCriteria/createMany`, metadata, options, fetch, false)
        ;
    const mutation = {
        ..._mutation,
        mutateAsync: async <T extends Prisma.TenantScreeningCriteriaCreateManyArgs>(
            args: Prisma.SelectSubset<T, Prisma.TenantScreeningCriteriaCreateManyArgs>,
            options?: Omit<(UseMutationOptions<Prisma.BatchPayload, DefaultError, Prisma.SelectSubset<T, Prisma.TenantScreeningCriteriaCreateManyArgs>> & ExtraMutationOptions), 'mutationFn'>
        ) => {
            return (await _mutation.mutateAsync(
                args,
                options as any
            )) as Prisma.BatchPayload;
        },
    };
    return mutation;
}

export function useFindManyTenantScreeningCriteria<TArgs extends Prisma.TenantScreeningCriteriaFindManyArgs, TQueryFnData = Array<Prisma.TenantScreeningCriteriaGetPayload<TArgs> & { $optimistic?: boolean }>, TData = TQueryFnData, TError = DefaultError>(args?: Prisma.SelectSubset<TArgs, Prisma.TenantScreeningCriteriaFindManyArgs>, options?: (Omit<UseQueryOptions<TQueryFnData, TError, TData>, 'queryKey'> & ExtraQueryOptions)) {
    const { endpoint, fetch } = getHooksContext();
    return useModelQuery<TQueryFnData, TData, TError>('TenantScreeningCriteria', `${endpoint}/tenantScreeningCriteria/findMany`, args, options, fetch);
}

export function useInfiniteFindManyTenantScreeningCriteria<TArgs extends Prisma.TenantScreeningCriteriaFindManyArgs, TQueryFnData = Array<Prisma.TenantScreeningCriteriaGetPayload<TArgs>>, TData = TQueryFnData, TError = DefaultError>(args?: Prisma.SelectSubset<TArgs, Prisma.TenantScreeningCriteriaFindManyArgs>, options?: Omit<UseInfiniteQueryOptions<TQueryFnData, TError, InfiniteData<TData>>, 'queryKey' | 'initialPageParam'>) {
    options = options ?? { getNextPageParam: () => null };
    const { endpoint, fetch } = getHooksContext();
    return useInfiniteModelQuery<TQueryFnData, TData, TError>('TenantScreeningCriteria', `${endpoint}/tenantScreeningCriteria/findMany`, args, options, fetch);
}

export function useSuspenseFindManyTenantScreeningCriteria<TArgs extends Prisma.TenantScreeningCriteriaFindManyArgs, TQueryFnData = Array<Prisma.TenantScreeningCriteriaGetPayload<TArgs> & { $optimistic?: boolean }>, TData = TQueryFnData, TError = DefaultError>(args?: Prisma.SelectSubset<TArgs, Prisma.TenantScreeningCriteriaFindManyArgs>, options?: (Omit<UseSuspenseQueryOptions<TQueryFnData, TError, TData>, 'queryKey'> & ExtraQueryOptions)) {
    const { endpoint, fetch } = getHooksContext();
    return useSuspenseModelQuery<TQueryFnData, TData, TError>('TenantScreeningCriteria', `${endpoint}/tenantScreeningCriteria/findMany`, args, options, fetch);
}

export function useSuspenseInfiniteFindManyTenantScreeningCriteria<TArgs extends Prisma.TenantScreeningCriteriaFindManyArgs, TQueryFnData = Array<Prisma.TenantScreeningCriteriaGetPayload<TArgs>>, TData = TQueryFnData, TError = DefaultError>(args?: Prisma.SelectSubset<TArgs, Prisma.TenantScreeningCriteriaFindManyArgs>, options?: Omit<UseSuspenseInfiniteQueryOptions<TQueryFnData, TError, InfiniteData<TData>>, 'queryKey' | 'initialPageParam'>) {
    options = options ?? { getNextPageParam: () => null };
    const { endpoint, fetch } = getHooksContext();
    return useSuspenseInfiniteModelQuery<TQueryFnData, TData, TError>('TenantScreeningCriteria', `${endpoint}/tenantScreeningCriteria/findMany`, args, options, fetch);
}

export function useFindUniqueTenantScreeningCriteria<TArgs extends Prisma.TenantScreeningCriteriaFindUniqueArgs, TQueryFnData = Prisma.TenantScreeningCriteriaGetPayload<TArgs> & { $optimistic?: boolean }, TData = TQueryFnData, TError = DefaultError>(args: Prisma.SelectSubset<TArgs, Prisma.TenantScreeningCriteriaFindUniqueArgs>, options?: (Omit<UseQueryOptions<TQueryFnData, TError, TData>, 'queryKey'> & ExtraQueryOptions)) {
    const { endpoint, fetch } = getHooksContext();
    return useModelQuery<TQueryFnData, TData, TError>('TenantScreeningCriteria', `${endpoint}/tenantScreeningCriteria/findUnique`, args, options, fetch);
}

export function useSuspenseFindUniqueTenantScreeningCriteria<TArgs extends Prisma.TenantScreeningCriteriaFindUniqueArgs, TQueryFnData = Prisma.TenantScreeningCriteriaGetPayload<TArgs> & { $optimistic?: boolean }, TData = TQueryFnData, TError = DefaultError>(args: Prisma.SelectSubset<TArgs, Prisma.TenantScreeningCriteriaFindUniqueArgs>, options?: (Omit<UseSuspenseQueryOptions<TQueryFnData, TError, TData>, 'queryKey'> & ExtraQueryOptions)) {
    const { endpoint, fetch } = getHooksContext();
    return useSuspenseModelQuery<TQueryFnData, TData, TError>('TenantScreeningCriteria', `${endpoint}/tenantScreeningCriteria/findUnique`, args, options, fetch);
}

export function useFindFirstTenantScreeningCriteria<TArgs extends Prisma.TenantScreeningCriteriaFindFirstArgs, TQueryFnData = Prisma.TenantScreeningCriteriaGetPayload<TArgs> & { $optimistic?: boolean }, TData = TQueryFnData, TError = DefaultError>(args?: Prisma.SelectSubset<TArgs, Prisma.TenantScreeningCriteriaFindFirstArgs>, options?: (Omit<UseQueryOptions<TQueryFnData, TError, TData>, 'queryKey'> & ExtraQueryOptions)) {
    const { endpoint, fetch } = getHooksContext();
    return useModelQuery<TQueryFnData, TData, TError>('TenantScreeningCriteria', `${endpoint}/tenantScreeningCriteria/findFirst`, args, options, fetch);
}

export function useSuspenseFindFirstTenantScreeningCriteria<TArgs extends Prisma.TenantScreeningCriteriaFindFirstArgs, TQueryFnData = Prisma.TenantScreeningCriteriaGetPayload<TArgs> & { $optimistic?: boolean }, TData = TQueryFnData, TError = DefaultError>(args?: Prisma.SelectSubset<TArgs, Prisma.TenantScreeningCriteriaFindFirstArgs>, options?: (Omit<UseSuspenseQueryOptions<TQueryFnData, TError, TData>, 'queryKey'> & ExtraQueryOptions)) {
    const { endpoint, fetch } = getHooksContext();
    return useSuspenseModelQuery<TQueryFnData, TData, TError>('TenantScreeningCriteria', `${endpoint}/tenantScreeningCriteria/findFirst`, args, options, fetch);
}

export function useUpdateTenantScreeningCriteria(options?: Omit<(UseMutationOptions<(TenantScreeningCriteria | undefined), DefaultError, Prisma.TenantScreeningCriteriaUpdateArgs> & ExtraMutationOptions), 'mutationFn'>) {
    const { endpoint, fetch } = getHooksContext();
    const _mutation =
        useModelMutation<Prisma.TenantScreeningCriteriaUpdateArgs, DefaultError, TenantScreeningCriteria, true>('TenantScreeningCriteria', 'PUT', `${endpoint}/tenantScreeningCriteria/update`, metadata, options, fetch, true)
        ;
    const mutation = {
        ..._mutation,
        mutateAsync: async <T extends Prisma.TenantScreeningCriteriaUpdateArgs>(
            args: Prisma.SelectSubset<T, Prisma.TenantScreeningCriteriaUpdateArgs>,
            options?: Omit<(UseMutationOptions<(CheckSelect<T, TenantScreeningCriteria, Prisma.TenantScreeningCriteriaGetPayload<T>> | undefined), DefaultError, Prisma.SelectSubset<T, Prisma.TenantScreeningCriteriaUpdateArgs>> & ExtraMutationOptions), 'mutationFn'>
        ) => {
            return (await _mutation.mutateAsync(
                args,
                options as any
            )) as (CheckSelect<T, TenantScreeningCriteria, Prisma.TenantScreeningCriteriaGetPayload<T>> | undefined);
        },
    };
    return mutation;
}

export function useUpdateManyTenantScreeningCriteria(options?: Omit<(UseMutationOptions<Prisma.BatchPayload, DefaultError, Prisma.TenantScreeningCriteriaUpdateManyArgs> & ExtraMutationOptions), 'mutationFn'>) {
    const { endpoint, fetch } = getHooksContext();
    const _mutation =
        useModelMutation<Prisma.TenantScreeningCriteriaUpdateManyArgs, DefaultError, Prisma.BatchPayload, false>('TenantScreeningCriteria', 'PUT', `${endpoint}/tenantScreeningCriteria/updateMany`, metadata, options, fetch, false)
        ;
    const mutation = {
        ..._mutation,
        mutateAsync: async <T extends Prisma.TenantScreeningCriteriaUpdateManyArgs>(
            args: Prisma.SelectSubset<T, Prisma.TenantScreeningCriteriaUpdateManyArgs>,
            options?: Omit<(UseMutationOptions<Prisma.BatchPayload, DefaultError, Prisma.SelectSubset<T, Prisma.TenantScreeningCriteriaUpdateManyArgs>> & ExtraMutationOptions), 'mutationFn'>
        ) => {
            return (await _mutation.mutateAsync(
                args,
                options as any
            )) as Prisma.BatchPayload;
        },
    };
    return mutation;
}

export function useUpsertTenantScreeningCriteria(options?: Omit<(UseMutationOptions<(TenantScreeningCriteria | undefined), DefaultError, Prisma.TenantScreeningCriteriaUpsertArgs> & ExtraMutationOptions), 'mutationFn'>) {
    const { endpoint, fetch } = getHooksContext();
    const _mutation =
        useModelMutation<Prisma.TenantScreeningCriteriaUpsertArgs, DefaultError, TenantScreeningCriteria, true>('TenantScreeningCriteria', 'POST', `${endpoint}/tenantScreeningCriteria/upsert`, metadata, options, fetch, true)
        ;
    const mutation = {
        ..._mutation,
        mutateAsync: async <T extends Prisma.TenantScreeningCriteriaUpsertArgs>(
            args: Prisma.SelectSubset<T, Prisma.TenantScreeningCriteriaUpsertArgs>,
            options?: Omit<(UseMutationOptions<(CheckSelect<T, TenantScreeningCriteria, Prisma.TenantScreeningCriteriaGetPayload<T>> | undefined), DefaultError, Prisma.SelectSubset<T, Prisma.TenantScreeningCriteriaUpsertArgs>> & ExtraMutationOptions), 'mutationFn'>
        ) => {
            return (await _mutation.mutateAsync(
                args,
                options as any
            )) as (CheckSelect<T, TenantScreeningCriteria, Prisma.TenantScreeningCriteriaGetPayload<T>> | undefined);
        },
    };
    return mutation;
}

export function useDeleteTenantScreeningCriteria(options?: Omit<(UseMutationOptions<(TenantScreeningCriteria | undefined), DefaultError, Prisma.TenantScreeningCriteriaDeleteArgs> & ExtraMutationOptions), 'mutationFn'>) {
    const { endpoint, fetch } = getHooksContext();
    const _mutation =
        useModelMutation<Prisma.TenantScreeningCriteriaDeleteArgs, DefaultError, TenantScreeningCriteria, true>('TenantScreeningCriteria', 'DELETE', `${endpoint}/tenantScreeningCriteria/delete`, metadata, options, fetch, true)
        ;
    const mutation = {
        ..._mutation,
        mutateAsync: async <T extends Prisma.TenantScreeningCriteriaDeleteArgs>(
            args: Prisma.SelectSubset<T, Prisma.TenantScreeningCriteriaDeleteArgs>,
            options?: Omit<(UseMutationOptions<(CheckSelect<T, TenantScreeningCriteria, Prisma.TenantScreeningCriteriaGetPayload<T>> | undefined), DefaultError, Prisma.SelectSubset<T, Prisma.TenantScreeningCriteriaDeleteArgs>> & ExtraMutationOptions), 'mutationFn'>
        ) => {
            return (await _mutation.mutateAsync(
                args,
                options as any
            )) as (CheckSelect<T, TenantScreeningCriteria, Prisma.TenantScreeningCriteriaGetPayload<T>> | undefined);
        },
    };
    return mutation;
}

export function useDeleteManyTenantScreeningCriteria(options?: Omit<(UseMutationOptions<Prisma.BatchPayload, DefaultError, Prisma.TenantScreeningCriteriaDeleteManyArgs> & ExtraMutationOptions), 'mutationFn'>) {
    const { endpoint, fetch } = getHooksContext();
    const _mutation =
        useModelMutation<Prisma.TenantScreeningCriteriaDeleteManyArgs, DefaultError, Prisma.BatchPayload, false>('TenantScreeningCriteria', 'DELETE', `${endpoint}/tenantScreeningCriteria/deleteMany`, metadata, options, fetch, false)
        ;
    const mutation = {
        ..._mutation,
        mutateAsync: async <T extends Prisma.TenantScreeningCriteriaDeleteManyArgs>(
            args: Prisma.SelectSubset<T, Prisma.TenantScreeningCriteriaDeleteManyArgs>,
            options?: Omit<(UseMutationOptions<Prisma.BatchPayload, DefaultError, Prisma.SelectSubset<T, Prisma.TenantScreeningCriteriaDeleteManyArgs>> & ExtraMutationOptions), 'mutationFn'>
        ) => {
            return (await _mutation.mutateAsync(
                args,
                options as any
            )) as Prisma.BatchPayload;
        },
    };
    return mutation;
}

export function useAggregateTenantScreeningCriteria<TArgs extends Prisma.TenantScreeningCriteriaAggregateArgs, TQueryFnData = Prisma.GetTenantScreeningCriteriaAggregateType<TArgs>, TData = TQueryFnData, TError = DefaultError>(args: Prisma.SelectSubset<TArgs, Prisma.TenantScreeningCriteriaAggregateArgs>, options?: (Omit<UseQueryOptions<TQueryFnData, TError, TData>, 'queryKey'> & ExtraQueryOptions)) {
    const { endpoint, fetch } = getHooksContext();
    return useModelQuery<TQueryFnData, TData, TError>('TenantScreeningCriteria', `${endpoint}/tenantScreeningCriteria/aggregate`, args, options, fetch);
}

export function useSuspenseAggregateTenantScreeningCriteria<TArgs extends Prisma.TenantScreeningCriteriaAggregateArgs, TQueryFnData = Prisma.GetTenantScreeningCriteriaAggregateType<TArgs>, TData = TQueryFnData, TError = DefaultError>(args: Prisma.SelectSubset<TArgs, Prisma.TenantScreeningCriteriaAggregateArgs>, options?: (Omit<UseSuspenseQueryOptions<TQueryFnData, TError, TData>, 'queryKey'> & ExtraQueryOptions)) {
    const { endpoint, fetch } = getHooksContext();
    return useSuspenseModelQuery<TQueryFnData, TData, TError>('TenantScreeningCriteria', `${endpoint}/tenantScreeningCriteria/aggregate`, args, options, fetch);
}

export function useGroupByTenantScreeningCriteria<TArgs extends Prisma.TenantScreeningCriteriaGroupByArgs, HasSelectOrTake extends Prisma.Or<Prisma.Extends<'skip', Prisma.Keys<TArgs>>, Prisma.Extends<'take', Prisma.Keys<TArgs>>>, OrderByArg extends Prisma.True extends HasSelectOrTake ? { orderBy: Prisma.TenantScreeningCriteriaGroupByArgs['orderBy'] } : { orderBy?: Prisma.TenantScreeningCriteriaGroupByArgs['orderBy'] }, OrderFields extends Prisma.ExcludeUnderscoreKeys<Prisma.Keys<Prisma.MaybeTupleToUnion<TArgs['orderBy']>>>, ByFields extends Prisma.MaybeTupleToUnion<TArgs['by']>, ByValid extends Prisma.Has<ByFields, OrderFields>, HavingFields extends Prisma.GetHavingFields<TArgs['having']>, HavingValid extends Prisma.Has<ByFields, HavingFields>, ByEmpty extends TArgs['by'] extends never[] ? Prisma.True : Prisma.False, InputErrors extends ByEmpty extends Prisma.True
    ? `Error: "by" must not be empty.`
    : HavingValid extends Prisma.False
    ? {
        [P in HavingFields]: P extends ByFields
        ? never
        : P extends string
        ? `Error: Field "${P}" used in "having" needs to be provided in "by".`
        : [
            Error,
            'Field ',
            P,
            ` in "having" needs to be provided in "by"`,
        ]
    }[HavingFields]
    : 'take' extends Prisma.Keys<TArgs>
    ? 'orderBy' extends Prisma.Keys<TArgs>
    ? ByValid extends Prisma.True
    ? {}
    : {
        [P in OrderFields]: P extends ByFields
        ? never
        : `Error: Field "${P}" in "orderBy" needs to be provided in "by"`
    }[OrderFields]
    : 'Error: If you provide "take", you also need to provide "orderBy"'
    : 'skip' extends Prisma.Keys<TArgs>
    ? 'orderBy' extends Prisma.Keys<TArgs>
    ? ByValid extends Prisma.True
    ? {}
    : {
        [P in OrderFields]: P extends ByFields
        ? never
        : `Error: Field "${P}" in "orderBy" needs to be provided in "by"`
    }[OrderFields]
    : 'Error: If you provide "skip", you also need to provide "orderBy"'
    : ByValid extends Prisma.True
    ? {}
    : {
        [P in OrderFields]: P extends ByFields
        ? never
        : `Error: Field "${P}" in "orderBy" needs to be provided in "by"`
    }[OrderFields], TQueryFnData = {} extends InputErrors ?
    Array<PickEnumerable<Prisma.TenantScreeningCriteriaGroupByOutputType, TArgs['by']> &
    {
        [P in ((keyof TArgs) & (keyof Prisma.TenantScreeningCriteriaGroupByOutputType))]: P extends '_count'
        ? TArgs[P] extends boolean
        ? number
        : Prisma.GetScalarType<TArgs[P], Prisma.TenantScreeningCriteriaGroupByOutputType[P]>
        : Prisma.GetScalarType<TArgs[P], Prisma.TenantScreeningCriteriaGroupByOutputType[P]>
    }
    > : InputErrors, TData = TQueryFnData, TError = DefaultError>(args: Prisma.SelectSubset<TArgs, Prisma.SubsetIntersection<TArgs, Prisma.TenantScreeningCriteriaGroupByArgs, OrderByArg> & InputErrors>, options?: (Omit<UseQueryOptions<TQueryFnData, TError, TData>, 'queryKey'> & ExtraQueryOptions)) {
    const { endpoint, fetch } = getHooksContext();
    return useModelQuery<TQueryFnData, TData, TError>('TenantScreeningCriteria', `${endpoint}/tenantScreeningCriteria/groupBy`, args, options, fetch);
}

export function useSuspenseGroupByTenantScreeningCriteria<TArgs extends Prisma.TenantScreeningCriteriaGroupByArgs, HasSelectOrTake extends Prisma.Or<Prisma.Extends<'skip', Prisma.Keys<TArgs>>, Prisma.Extends<'take', Prisma.Keys<TArgs>>>, OrderByArg extends Prisma.True extends HasSelectOrTake ? { orderBy: Prisma.TenantScreeningCriteriaGroupByArgs['orderBy'] } : { orderBy?: Prisma.TenantScreeningCriteriaGroupByArgs['orderBy'] }, OrderFields extends Prisma.ExcludeUnderscoreKeys<Prisma.Keys<Prisma.MaybeTupleToUnion<TArgs['orderBy']>>>, ByFields extends Prisma.MaybeTupleToUnion<TArgs['by']>, ByValid extends Prisma.Has<ByFields, OrderFields>, HavingFields extends Prisma.GetHavingFields<TArgs['having']>, HavingValid extends Prisma.Has<ByFields, HavingFields>, ByEmpty extends TArgs['by'] extends never[] ? Prisma.True : Prisma.False, InputErrors extends ByEmpty extends Prisma.True
    ? `Error: "by" must not be empty.`
    : HavingValid extends Prisma.False
    ? {
        [P in HavingFields]: P extends ByFields
        ? never
        : P extends string
        ? `Error: Field "${P}" used in "having" needs to be provided in "by".`
        : [
            Error,
            'Field ',
            P,
            ` in "having" needs to be provided in "by"`,
        ]
    }[HavingFields]
    : 'take' extends Prisma.Keys<TArgs>
    ? 'orderBy' extends Prisma.Keys<TArgs>
    ? ByValid extends Prisma.True
    ? {}
    : {
        [P in OrderFields]: P extends ByFields
        ? never
        : `Error: Field "${P}" in "orderBy" needs to be provided in "by"`
    }[OrderFields]
    : 'Error: If you provide "take", you also need to provide "orderBy"'
    : 'skip' extends Prisma.Keys<TArgs>
    ? 'orderBy' extends Prisma.Keys<TArgs>
    ? ByValid extends Prisma.True
    ? {}
    : {
        [P in OrderFields]: P extends ByFields
        ? never
        : `Error: Field "${P}" in "orderBy" needs to be provided in "by"`
    }[OrderFields]
    : 'Error: If you provide "skip", you also need to provide "orderBy"'
    : ByValid extends Prisma.True
    ? {}
    : {
        [P in OrderFields]: P extends ByFields
        ? never
        : `Error: Field "${P}" in "orderBy" needs to be provided in "by"`
    }[OrderFields], TQueryFnData = {} extends InputErrors ?
    Array<PickEnumerable<Prisma.TenantScreeningCriteriaGroupByOutputType, TArgs['by']> &
    {
        [P in ((keyof TArgs) & (keyof Prisma.TenantScreeningCriteriaGroupByOutputType))]: P extends '_count'
        ? TArgs[P] extends boolean
        ? number
        : Prisma.GetScalarType<TArgs[P], Prisma.TenantScreeningCriteriaGroupByOutputType[P]>
        : Prisma.GetScalarType<TArgs[P], Prisma.TenantScreeningCriteriaGroupByOutputType[P]>
    }
    > : InputErrors, TData = TQueryFnData, TError = DefaultError>(args: Prisma.SelectSubset<TArgs, Prisma.SubsetIntersection<TArgs, Prisma.TenantScreeningCriteriaGroupByArgs, OrderByArg> & InputErrors>, options?: (Omit<UseSuspenseQueryOptions<TQueryFnData, TError, TData>, 'queryKey'> & ExtraQueryOptions)) {
    const { endpoint, fetch } = getHooksContext();
    return useSuspenseModelQuery<TQueryFnData, TData, TError>('TenantScreeningCriteria', `${endpoint}/tenantScreeningCriteria/groupBy`, args, options, fetch);
}

export function useCountTenantScreeningCriteria<TArgs extends Prisma.TenantScreeningCriteriaCountArgs, TQueryFnData = TArgs extends { select: any; } ? TArgs['select'] extends true ? number : Prisma.GetScalarType<TArgs['select'], Prisma.TenantScreeningCriteriaCountAggregateOutputType> : number, TData = TQueryFnData, TError = DefaultError>(args?: Prisma.SelectSubset<TArgs, Prisma.TenantScreeningCriteriaCountArgs>, options?: (Omit<UseQueryOptions<TQueryFnData, TError, TData>, 'queryKey'> & ExtraQueryOptions)) {
    const { endpoint, fetch } = getHooksContext();
    return useModelQuery<TQueryFnData, TData, TError>('TenantScreeningCriteria', `${endpoint}/tenantScreeningCriteria/count`, args, options, fetch);
}

export function useSuspenseCountTenantScreeningCriteria<TArgs extends Prisma.TenantScreeningCriteriaCountArgs, TQueryFnData = TArgs extends { select: any; } ? TArgs['select'] extends true ? number : Prisma.GetScalarType<TArgs['select'], Prisma.TenantScreeningCriteriaCountAggregateOutputType> : number, TData = TQueryFnData, TError = DefaultError>(args?: Prisma.SelectSubset<TArgs, Prisma.TenantScreeningCriteriaCountArgs>, options?: (Omit<UseSuspenseQueryOptions<TQueryFnData, TError, TData>, 'queryKey'> & ExtraQueryOptions)) {
    const { endpoint, fetch } = getHooksContext();
    return useSuspenseModelQuery<TQueryFnData, TData, TError>('TenantScreeningCriteria', `${endpoint}/tenantScreeningCriteria/count`, args, options, fetch);
}
import type { CreditScoreRange, AnnualIncome, MostRecentEviction } from '.zenstack/models';

export function useCheckTenantScreeningCriteria<TError = DefaultError>(args: { operation: PolicyCrudKind; where?: { createdById?: string; updatedById?: string; deletedById?: string; id?: string; leaseTermsId?: string; isEnabled?: boolean; creditScoreRange?: CreditScoreRange; annualIncome?: AnnualIncome; mostRecentEviction?: MostRecentEviction }; }, options?: (Omit<UseQueryOptions<boolean, TError, boolean>, 'queryKey'> & ExtraQueryOptions)) {
    const { endpoint, fetch } = getHooksContext();
    return useModelQuery<boolean, boolean, TError>('TenantScreeningCriteria', `${endpoint}/tenantScreeningCriteria/check`, args, options, fetch);
}
